import SvgIcon from "@mui/material/SvgIcon";

export const ReferralsRewardsIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M16 11.2a4 4 0 110-8 4 4 0 010 8zM16 4a3.2 3.2 0 100 6.4A3.2 3.2 0 0016 4zM16.4 20H10a1.2 1.2 0 01-1.2-1.2v-1.2a7.193 7.193 0 013.82-6.353l.352-.188.377.706-.353.188A6.394 6.394 0 009.6 17.6v1.2a.4.4 0 00.4.4h6.4v.8zM7.2 8a4 4 0 110-8 4 4 0 010 8zm0-7.2a3.2 3.2 0 100 6.4 3.2 3.2 0 000-6.4zM7.6 16.8H1.2A1.2 1.2 0 010 15.6v-1.2a7.193 7.193 0 013.82-6.353l.352-.189.377.706-.353.189A6.394 6.394 0 00.8 14.4v1.2a.4.4 0 00.4.4h6.4v.8zM19.494 17.785l2.738.44A2.093 2.093 0 0124 20.299c0 1.158-.943 2.1-2.101 2.1h-.7v1.2a.4.4 0 01-.8 0v-1.2h-.74a2.207 2.207 0 01-1.906-1.1.4.4 0 01.693-.4c.25.433.715.7 1.214.7h2.24c.717 0 1.3-.583 1.3-1.3 0-.642-.46-1.182-1.094-1.284l-2.737-.44a2.093 2.093 0 01-1.768-2.074c0-1.159.942-2.101 2.1-2.101h.7v-1.2a.4.4 0 01.8 0v1.2h.74c.784 0 1.514.421 1.906 1.1a.4.4 0 01-.693.4c-.25-.432-.715-.7-1.213-.7H19.7c-.718 0-1.301.584-1.301 1.3 0 .642.46 1.183 1.094 1.285z"></path>
    </svg>
  </SvgIcon>
);
